<template>
  <div v-show="isLoaded" class="mBannerGold-container" v-observe-visibility="startAnimate">
    <img class="mBannerGold-image" :src="banner" alt="BannerGold">
    <img class="mBannerGold-image-desktop" :src="banner_desktop" alt="BannerGold">
    <div class="mBannerGold-title-container">
      <h1 class="mBannerGold-title" :class="{animate: animate}">
        StrongBow
      </h1>
      <h2 class="mBannerGold-subtitle" :class="{animate: animate}">
        Gold Apple
      </h2>
    </div>
  </div>
</template>

<script>
import banner from '@/assets/gold-apple/gold_apple.png';
import banner_desktop from '@/assets/gold-apple/banner_desktop.png';
import { mapGetters } from "vuex";
import Bowser from "bowser"; 

export default {
  name: "BannerGold",
  data() {
    return {
      banner,
      banner_desktop,
      animate: false,
      isSafari: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  methods: {
    startAnimate(isVisible) {
      if(isVisible) {
        this.animate=true
      }  
    }
  },
  components: {},
  beforeMount() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName()=='Safari') {
      this.isSafari = true
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/GoldApple/BannerGold.scss";
</style>
